import React from 'react'

const RentACarData =  [
{
    id: 1,
    title: 'Exclusive Fleet',
    detail: 'Access a curated collection of the world’s most prestigious cars.',
},
{
    id: 2,
    title: 'Seamless Experience',
    detail: 'Effortless booking and flexible rental options to fit your schedule',
},
{
    id: 3,
    title: 'Premium Service',
    detail: 'Dedicated support ensuring a smooth and luxurious rental experience.',
},
{
    id: 4,
    title: 'Reliability & Trust',
    detail: 'Depend on our commitment to quality and customer satisfaction.',
},

]
export default RentACarData